import React, { Component } from 'react'
import { RadioInput, Select, TextInput } from './Form'
import { DumbField } from '../Field'
import { GET_GROUP_ITEMS } from '../../../requests'
import { getCountryOptions } from '../selectOptions'
import {noop} from 'utilities'

const STATE_NAME = process.env.STATE_NAME.toUpperCase();

export default class FormationLocale extends Component{
  constructor(){
    super()
    this.state = {
      stateOptions: [{value: '0', label: 'loading...'}],
      countryOptions: getCountryOptions()
    }
  }
  componentDidMount = () => {
    this.focus()
  }
  setFieldValue = (value, e) => {
    this.props.onChange({...this.props.value, [e.target.name]: value}, e)
  }
  componentDidMount = () => {
    this.getOptionsByType('STATE')
      .then(options => {
        let computedOptions = options;
        if(this.props.excludeCurrentState){
          computedOptions = options.filter(({value}) => value !== STATE_NAME)
        }
        this.setState({stateOptions: computedOptions})
      })
  }
  getOptionsByType = type => (
    new Promise((resolve, reject) => {
      GET_GROUP_ITEMS(type, res => {
        if(Array.isArray(res)){
          resolve(res.map(option => ({...option, value: option.label})))
        }else{
          resolve(res.options.map(option => ({...option, value: option.label})))
        }
      })
    })
  )
  focus = () => {
    this.radio.focus()
  }
  render(){
    const { value, disabled, fieldId, label } = this.props;
    const { stateOptions, countryOptions } = this.state;
    return(
      <div>
        <RadioInput
          value={value.FORMATION_TYPE}
          name='FORMATION_TYPE'
          fieldId={fieldId}
          options={[
            {value: 'STATE', label: 'United States'},
            {value: 'COUNTRY', label: 'Country'},
            {value: 'OTHER', label: 'Other Jurisdiction'}
          ]}
          label={label}
          onChange={this.setFieldValue}
          disabled={disabled}
          ref={radio => { this.radio = radio }}
        />
        <div className='row'>
          <div className='col-sm-7 col-md-6 col-lg-5'>
            <div className='dependent-field no-margin-bottom'>
              {
                value.FORMATION_TYPE === 'STATE' &&
                <DumbField label='State' className='no-margin-bottom'>
                  <Select
                    value={value.STATE}
                    name='STATE'
                    options={[{value: '', label: '[Select a State]'}, ...stateOptions]}
                    onChange={this.setFieldValue}
                    onBlur={noop}
                    disabled={disabled}
                  />
                </DumbField>
              }
              {
                value.FORMATION_TYPE === 'COUNTRY' &&
                <DumbField label='Country' className='no-margin-bottom'>
                  <Select
                    value={value.COUNTRY}
                    name='COUNTRY'
                    options={[{value: '', label: '[Select a Country]'}, ...countryOptions]}
                    onChange={this.setFieldValue}
                    onBlur={noop}
                    disabled={disabled}
                  />
                </DumbField>
              }
              {
                value.FORMATION_TYPE === 'OTHER' &&
                <DumbField label='Other Jurisdiction' className='no-margin-bottom'>
                  <TextInput
                    value={value.OTHER}
                    name='OTHER'
                    width='100%'
                    onChange={this.setFieldValue}
                    onBlur={noop}
                    disabled={disabled}
                  />
                </DumbField>
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Wizard2/fieldComponents/FormationLocale.js